import React, { Component } from 'react';
import { ToastStore } from './components/ToastStore';
import AppToastContainer from './components/AppToastContainer';
import { connect } from 'react-redux';
import { Animate } from 'react-show';
import history from './history';

import './include/bootstrap';
import './fonts/open-sans.css';
import './fonts/open-sans-600.css';
import './fonts/silka.css';
import './fonts/twkeverett.css';
import './fonts/fa/css/fontawesome-all.min.css';
import './index.css';
import { Router, Switch, Route } from 'react-router-dom';

//COMPONENTS
import Header from './views/components/navigation/header';
import Footer from './views/components/navigation/footer';

//PAGES
import PackageSelectionPage from './views/PackageSelectionPage';
import PackageConfigurationPage from './views/PackageConfigurationPage';
import CartPage from './views/CartPage';
import CheckoutPage from './views/CheckoutPage';
import PaymentStatusPage from './views/PaymentStatusPage';
import OrderStatusPage from './views/OrderStatusPage';
import PxPayPage from './views/PxPayPage';
import RegistrationPage from './views/RegistrationPage';
import EmailValidationPage from './views/EmailValidationPage';
import AccountAuthorisationPage from './views/AccountAuthorisationPage';
import StripePaymentPage from './views/StripePaymentPage';
import PaymentPxPayPage from './views/PaymentPxPayPage';
import ProcessPxPayPage from './views/ProcessPxPayPage';
import WindcavePaymentStatusPage from './views/WindcavePaymentStatusPage';
import HelpMeChooseWizardPage from './views/HelpMeChooseWizardPage';

//SERVICES
import ProductsService from './services/productsService';
import AddProductsService from './services/addProductsService';
import LoginService from './services/customerRegistration/loginService';
import AuthorisationService from './services/stripe/authorisationService';
import ProductItemsService from './services/productItemsService';
import SegmentAnalytics from './services/segmentAnalytics';
import OrderService from './services/orderService';

//UTILS
import ScrollToTop from './utils/scrollToTop';

const products_service = new ProductsService();
const add_products_service = new AddProductsService();
const email_validation_service = new LoginService();
const authorisation_service = new AuthorisationService();
const product_items_service = new ProductItemsService();
const segment_analytics_service = new SegmentAnalytics();
const order_service = new OrderService();

history.listen((location) => {
  if (window.ga !== undefined) {
    window.ga('set', 'page', `${location.pathname}${location.search}`);
    window.ga('send', 'pageview');
  }

  if (window.dataLayer !== undefined) {
    //Tag Manager PageView
    window.dataLayer.push({
      event: 'pageView',
      action: `${location.pathname}${location.search}`
    });
  }

  if (window._mfq !== undefined) {
    //Mouseflow route
    window._mfq.push(['newPageView', `${location.pathname}${location.search}`]);
  }

  if (window._elqQ !== undefined) {
    //Eloqua
    window._elqQ.push(['elqTrackPageView', `${location.pathname}${location.search}`]);
  }
  console.log('page change event');
});

class App extends Component {
  constructor(props) {
    super(props);

    window.dataLayer.push({
      originalLocation: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`
    });

    const escape = require('escape-html');
    const pageView = escape(`${window.location.pathname}${window.location.search}`);

    window.dataLayer.push({
      event: 'pageView',
      action: pageView
    });

    this.state = {
      isMobile: false
    };
  }

  normalizeLegacyHashbangUrl() {
    if (window.location.hash && window.location.hash.startsWith('#!/')) {
      const normalizedPath = window.location.hash.slice(2);
      if (/^\/[^<>"'`]*$/.test(normalizedPath)) {
        window.history.replaceState(null, '', normalizedPath);
      }
    }
  }

  componentDidMount() {
    this.normalizeLegacyHashbangUrl();

    if (/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent)) {
      this.setState({
        isMobile: true
      });
    }
  }

  render() {
    return (
      <div className='App'>
        <Header
          isMobile={this.state.isMobile}
          ProductItemsService={product_items_service}
          SegmentAnalytics={segment_analytics_service}
        />

        <Router history={history}>
          <div className='main-content'>
            <ScrollToTop>
              <Switch>
                <Route
                  exact
                  path='/'
                  render={(props) => (
                    <CartPage
                      {...props}
                      SegmentAnalytics={segment_analytics_service}
                      OrderService={order_service}
                    />
                  )}
                />
                <Route exact path='/cart' render={(props) => <CartPage {...props} />} />
                <Route
                  exact
                  path='/product/:friendly_name'
                  render={(props) => (
                    <PackageSelectionPage
                      {...props}
                    />
                  )}
                />
                <Route
                  exact
                  path='/product_config/:product_id'
                  render={(props) => (
                    <PackageConfigurationPage
                      {...props}
                      ProductsService={products_service}
                      SegmentAnalytics={segment_analytics_service}
                      OrderService={order_service}
                    />
                  )}
                />
                <Route
                  exact
                  path='/checkout'
                  render={(props) => (
                    <CheckoutPage
                      {...props}
                      SegmentAnalytics={segment_analytics_service}
                      ProductItemsService={product_items_service}
                    />
                  )}
                />
                <Route
                  exact
                  path='/payment/:payment_id'
                  render={(props) => (
                    <PaymentStatusPage {...props} SegmentAnalytics={segment_analytics_service} />
                  )}
                />
                <Route
                  exact
                  path='/order_status'
                  render={(props) => (
                    <OrderStatusPage {...props} SegmentAnalytics={segment_analytics_service} />
                  )}
                />
                <Route
                  exact
                  path='/pxpay'
                  render={(props) => (
                    <PxPayPage {...props} SegmentAnalytics={segment_analytics_service} />
                  )}
                />
                <Route
                  exact
                  path='/account_authorisation'
                  render={(props) => (
                    <AccountAuthorisationPage {...props} AuthorisationService={authorisation_service} />
                  )}
                />
                <Route
                  exact
                  path='/stripe/:charge_id'
                  render={(props) => <StripePaymentPage {...props} />}
                />
                <Route
                  exact
                  path='/register'
                  render={(props) => (
                    <RegistrationPage
                      {...props}
                      LoginService={email_validation_service}
                      SegmentAnalytics={segment_analytics_service}
                    />
                  )}
                />
                <Route
                  exact
                  path='/email_validation'
                  render={(props) => (
                    <EmailValidationPage
                      {...props}
                      LoginService={email_validation_service}
                      ProductItemsService={product_items_service}
                      SegmentAnalytics={segment_analytics_service}
                      OrderService={order_service}
                    />
                  )}
                />
                <Route
                  exact
                  path='/payment_pxpay/:payment_token'
                  render={(props) => (
                    <PaymentPxPayPage {...props} SegmentAnalytics={segment_analytics_service} />
                  )}
                />
                <Route
                  exact
                  path='/process_pxpay'
                  render={(props) => (
                    <ProcessPxPayPage {...props} SegmentAnalytics={segment_analytics_service} />
                  )}
                />
                <Route
                  exact
                  path='/payment_pxpay_status'
                  render={(props) => (
                    <WindcavePaymentStatusPage
                      {...props}
                      SegmentAnalytics={segment_analytics_service}
                    />
                  )}
                />
                <Route
                  exact
                  path='/product/rp-data-professional/:helpMeChoose'
                  render={(props) => (
                    <HelpMeChooseWizardPage {...props} SegmentAnalytics={segment_analytics_service} />
                  )}
                />
                <AppToastContainer store={ToastStore} />
              </Switch>
            </ScrollToTop>
          </div>
        </Router>

        <Footer SegmentAnalytics={segment_analytics_service} />
      </div>
    );
  }
}

let AppPage = connect()(App);

export default AppPage;
